define(
    'viewmodels/secured/explorer/details/tabs/actions/actionsModifyfield/actionsModifyfield',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "services/service.libraries",
        "services/service.documents",
        "providers/dataprovider",
        "services/service.dialog",
        "i19n!i19n/strings",
        "plugins/router"
    ],
    function (ctx, ViewModel, librariesService, documentService, dataProvider, dialogService, i19n, router) {

        var comboBox;
        var comboFieldList;
        var txtDatetime;
        var txtDate;
        var txtString;
        var chkData;
        var txtNotes;
        var txtIntegral;
        var txtCurrency;

        var vm = new ViewModel(
        {
            i19n: i19n,
            fieldList: ko.observableArray(),
            comboList: ko.observableArray(),
            libraryId: ko.observable(),
            correctField: ko.observable(),
            modifybutton: ko.observable(false),
            modifiyFieldEnabled: ko.observable(false),
            fields: {
                combo: ko.observable(false),
                string: ko.observable(false),
                notes: ko.observable(false),
                datetime: ko.observable(false),
                bit: ko.observable(false),
                date: ko.observable(false),
                integral: ko.observable(false),
                currency: ko.observable(false)
            }
        });

        vm.activate = function () {
            var documents = sessionStorage.getItem("modifyfield");
            var jDocuments = JSON.parse(documents);

            vm.libraryId(jDocuments[0].libraryId);

            dataProvider.documents
            .getLibraryModifyFieldDocumentSchema(vm.libraryId())
            .done(function (results) {
                results.columns = _.where(results.columns, { hidden: false });
                vm.fieldList(results.columns);
                if (comboFieldList) {
                    comboFieldList.dataSource.read();
                    comboFieldList.select(0);
                }
            });
            
            toggleVisibility(false, false, false, false, false, false, false, false);

        };
        vm.attached = function () {            
            comboFieldList = $("#masterList").kendoDropDownList({
                dataTextField: "title",
                dataValueField: "field",
                optionLabel: i19n.to.selectafieldtomodify,
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(vm.fieldList());
                        },
                    },
                    sort: { field: "title", dir: "asc" }
                },
                change: onChange
            }).data("kendoDropDownList");

            txtDatetime = $("#inputDatetime").kendoDateTimePicker({ format: "g" }).data("kendoDateTimePicker"); //d MMM yyyy hh:mm tt
            txtDate = $("#inputDate").kendoDatePicker({ format: "d" }).data("kendoDateTimePicker"); //d MMM yyyy
            txtString = $("#inputString").val();
            chkData = $("#inputCheck").val();
            txtNotes = $("#inputNotes").val();
        };

        vm.modifyField = function () {

            function chkTrueorfalse() {
                return $("#inputCheck").is(":checked") ? 'true' : 'false';
            }

            function resetComboBox() {
                comboBox.element.val('');
                comboBox.selectedIndex = -1;
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.combo(false);
            }

            function resetString() {
                $("#inputString").val('');
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.string(false);
            }

            function resetNotes() {
                $("#inputNotes").val('');
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.notes(false);
            }

            function resetDateTime() {
                $("#inputDatetime").val('');
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.datetime(false);
            }

            function resetDate() {
                $("#inputDate").val('');
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.date(false);
            }

            function resetBoolean() {
                $("#inputCheck").removeAttr("checked");
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.bit(false);
            }

            function resetCurrency() {
                $("#inputCurrency").val('');
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.currency(false);
            }

            function resetIntegral() {
                $("#inputIntegral").val('');
                $("#masterList").attr('selectedIndex', 0);
                vm.fields.integral(false);
            }

            function resetObjects(fields) {
                switch (getFieldType(fields)) {
                    case "combo":
                        resetComboBox();
                        break;
                    case "string":
                        resetString();
                        break;
                    case "notes":
                        resetNotes();
                        break;
                    case "datetime":
                        resetDateTime();
                        break;
                    case "date":
                        resetDate();
                        break;
                    case "boolean":
                        resetBoolean();
                        break;
                    case "currency":
                        resetCurrency();
                        break;
                    case "integral":
                        resetIntegral();
                        break;
                }
            }

            var toModify = "";
            var documents = sessionStorage.getItem("modifyfield");
            var jDocuments = JSON.parse(documents);            
            var field = $("#masterList").val();

            switch (getFieldType(field)) {
                case "combo":
                    toModify = String.format('{"{0}":"{1}"}', field, $("#combolist").val());
                    break;
                case "string":
                    toModify = String.format('{"{0}":"{1}"}', field, $("#inputString").val());
                    break;
                case "notes":
                    toModify = String.format('{"{0}":"{1}"}', field, $("#inputNotes").val());
                    break;
                case "datetime":                    
                    var m = moment(txtDatetime.value());
                    toModify = String.format('{"{0}":"{1}"}', field, m.format());

                    break;
                case "date":
                    var m = moment(txtDatetime.value());
                    toModify = String.format('{"{0}":"{1}"}', field, m.format());

                    break;
                case "boolean":
                    toModify = String.format('{"{0}":"{1}"}', field, chkTrueorfalse());
                    break;
                case "integral":
                    toModify = String.format('{"{0}":"{1}"}', field, $("#inputIntegral").val());
                    break;
                case "currency":
                    toModify = String.format('{"{0}":"{1}"}', field, $("#inputCurrency").val());
                    break;
            }

            documentService.actions
            .modifyFieldDocuments(toModify, jDocuments)
            .done(function (result) {
                var promise;
                if (!result.success) {
                    dialogService.showDocumentActionErrorDialog(result);
                } else {
                    resetObjects(field);

                    ctx.onReloadFolders("");

                    promise = dialogService.showMessageBox("Modify Field ", "Documents Updated", [{ label: "Ok", message: "" }]);
                    promise.then(function () {                        
                        if (sessionStorage.__url) {
                            window.location.href = sessionStorage.__url;
                        } else {
                            router.navigate("explorer");
                        }
                        //router.navigate("explorer");                      
                    });
                }
            });
        };
        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        return vm;

        function onChange() {
            vm.modifiyFieldEnabled(true);

            var value = $("#masterList").val();
            var libraryid = vm.libraryId();

            switch (getFieldType(value)) {
                case "combo":
                    if (isComboPerson(value)) {
                        value = "person";
                    } else {
                        value = changeFieldforLookup(value);
                    }
                    var placeholder = placeHolder(value);
                    librariesService.getLookupValues(libraryid, value)
                                     .done(function (lookupValues) {
                                         var results = _.map(lookupValues, function (listValue) {
                                             var result = {
                                                 name: listValue.name,
                                                 id: listValue.id
                                             };
                                             
                                             return result;
                                         });
                                         results.splice(0, 0, {name: '', id: null});
                                         comboBox = $("#combolist").kendoDropDownList({
                                             dataTextField: "name",
                                             dataValueField: "id",
                                             optionLabel: placeholder,
                                             dataSource: results
                                         }).data("kendoDropDownList");
                                     });
                    toggleVisibility(true, false, false, false, false, false, false, false);
                    //comboBox.text(comboBox.options.optionLabel);
                    //comboBox.element.val("");
                    //comboBox.selectedIndex = -1;
                    break;
                case "string":
                    toggleVisibility(false, true, false, false, false, false, false, false);
                    $("#inputString").attr("placeholder", placeholderObject("string", value));
                    $("#inputString").val("");
                    break;
                case "notes":
                    toggleVisibility(false, false, true, false, false, false, false, false);
                    $("#inputNotes").val("");
                    break;
                case "datetime":
                    toggleVisibility(false, false, false, true, false, false, false, false);
                    $("#inputDatetime").attr("placeholder", placeholderObject("datetime", value));
                    $(".k-datetimepicker input").val("");
                    break;
                case "date":
                    toggleVisibility(false, false, false, false, true, false, false, false);
                    $("#inputDate").attr("placeholder", placeholderObject("date", value));
                    $(".k-datepicker input").val("");
                    break;
                case "boolean":
                    toggleVisibility(false, false, false, false, false, true, false, false);
                    $("#lblCheck").text(placeholderObject("boolean", value));
                    $("#inputCheck").attr("checked", false);
                    break;
                case "integral":
                    toggleVisibility(false, false, false, false, false, false, true, false);
                    var placeholderIntegral = placeholderObject("integral", value);
                    txtIntegral = $("#inputIntegral").kendoNumericTextBox({
                        format: "#",
                        min: 0,
                        max: 1000000000,
                        decimals: 0,
                        step: 1,
                        placeholder: placeholderIntegral
                    }).data("kendoNumericTextBox");
                    txtIntegral._old = txtIntegral._value;
                    txtIntegral._value = null;
                    txtIntegral._text.val(txtIntegral._value);
                    txtIntegral.element.val(txtIntegral._value);
                    break;
                case "currency":
                    toggleVisibility(false, false, false, false, false, false, false, true);
                    var placeholderCurrency = placeholderObject("currency", value);
                    txtCurrency = $("#inputCurrency").kendoNumericTextBox({
                        format: "c",
                        decimals: 2,
                        step: 1,
                        placeholder: placeholderCurrency
                    }).data("kendoNumericTextBox");
                    txtCurrency._old = txtCurrency._value;
                    txtCurrency._value = null;
                    txtCurrency._text.val(txtCurrency._value);
                    txtCurrency.element.val(txtCurrency._value);
                    break;
                default:
                    toggleVisibility(false, false, false, false, false, false, false, false);
                    vm.modifiyFieldEnabled(false);
            }
        }
        function getFieldType(field) {
            var fields = vm.fieldList();
            for (var i = 0, il = fields.length; i < il; i++) {

                if (fields[i].field === field) {
                    if (isNotes(field)) {
                        return "notes";
                    } else if (isCombo(field)) {
                        return "combo";
                    } else {
                        return fields[i].type;
                    }
                }
            }
            return null;
        }
        function placeholderObject(fieldType, field) {
            var fields = vm.fieldList();

            for (var i = 0, il = fields.length; i < il; i++) {
                if (fields[i].field === field) {
                    if (fieldType === "string")
                        return i19n.to.pleaseenterthe + " " + fields[i].title;
                    else if (fieldType === "datetime")
                        return i19n.to.pleasechoosedateandtimeof + " " + fields[i].title;
                    else if (fieldType === "date")
                        return i19n.to.pleasechoosedateof + " " + fields[i].title;
                    else if (fieldType === "boolean")
                        return fields[i].title;
                    else if (fieldType === "currency")
                        return i19n.to.pleaseenterthe + " " + fields[i].title;
                    else if (fieldType === "integral")
                        return i19n.to.pleaseenterthe + " " + fields[i].title;
                }
            }

            return null;
        }
        function placeHolder(field) {
            var holder = "";
            switch (field) {
                case "docType":
                    holder = i19n.to.selectadocumenttype;
                    break;
                case "period":
                    holder = i19n.to.selectaperiod;
                    break;
                case "privilegedReason":
                    holder = i19n.to.selectapriviledgedreason;
                    break;
                case "location":
                    holder = i19n.to.selectalocation;
                    break;
                case "category":
                    holder = i19n.to.selectacategory;
                    break;
                case "index":
                    holder = i19n.to.selectanindex;
                    break;
                case "docStatus":
                    holder = i19n.to.selectadocumentstatus;
                    break;
                case "year":
                    holder = i19n.to.selectayear;
                    break;
                case "person":
                    holder = i19n.to.selectaperson;
                    break;
                case "documentClass":
                    holder = i19n.to.selectaclass;
                    break;
            }
            return holder;
        }
        function isCombo(field) {
            var lookup = ["category", "docStatus", "docType", "index", "year", "location", "privilegedReason", "period",
                "lastReviewedBy", "author", "nextReviewBy", "responsiblePerson", "assignedTo"];

            if (lookup.indexOf(field) === -1)
                return false;

            return true;
        }
        function changeFieldforLookup(currentField) {
            var lookup = ["categoryId", "category", "docStatusId", "docStatus", "docTypeId", "docType", "indexId", "index", "yearId", "year",
                            "locationId", "location", "privilegedReasonId", "privilegedReason", "periodId", "period"];

            var found = lookup.indexOf(currentField);
            var newValue = "";
            if (found >= 0)
                newValue = currentField;
            else {
                switch (currentField) {
                    case "categoryId":
                        newValue = "category";
                        break;
                    case "docStatusId":
                        newValue = "docStatus";
                        break;
                    case "docTypeId":
                        newValue = "docType";
                        break;
                    case "indexId":
                        newValue = "index";
                        break;
                    case "yearId":
                        newValue = "year";
                        break;
                    case "locationId":
                        newValue = "location";
                        break;
                    case "privilegedReasonId":
                        newValue = "privilegedReason";
                        break;
                    case "periodId":
                        newValue = "period";
                        break;
                    case "documentClass":
                        newValue = "documentClass";
                        break;
                }
            }

            return newValue;
        }
        function isComboPerson(field) {
            var lookup = ["lastReviewedByPersonId", "lastReviewedBy", "nextReviewByPersonId", "nextReviewBy",
              "authorPersonId", "author", "nextReviewByPersonId", "nextReviewBy", "responsiblePersonId", "responsiblePerson", "assignedToPersonId", "assignedTo"];

            if (lookup.indexOf(field) === -1)
                return false;

            return true;
        }
        function isNotes(field) {
            if (field === "notes")
                return true;

            return false;
        }
        function modifyVisible() {
            vm.modifybutton(true);
        }
        function toggleVisibility(combo,
                                     string,
                                     notes,
                                     datetime,
                                     date,
                                     bit,
                                     integral,
                                     currency) {

            vm.fields.combo(combo);
            vm.fields.string(string);
            vm.fields.notes(notes);
            vm.fields.datetime(datetime);
            vm.fields.date(date);
            vm.fields.bit(bit);
            vm.fields.integral(integral);
            vm.fields.currency(currency);
        }
    });



